module.exports = __webpack_public_path__ + "static/media/6k_website_logo_Platinum_veolia.676195e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/6k_website_logo_Platinum_veolia.jpg
// module id = 106
// module chunks = 0